import type { BreakpointBasedProp } from '../shared/types';
import { Breakpoint } from './../shared/types';
export function breakpointBasedPropToClassNames<T = unknown>(
  prop: BreakpointBasedProp<T>,
  key?: string,
  prefix = '_',
): string[] {
  const [base, breakpoints] = Array.isArray(prop) ? prop : [prop];
  const result = [];
  const keyPart = key ? `${key}-` : '';
  if (base) {
    result.push(`${prefix}${keyPart}${base}`);
  }
  if (breakpoints) {
    (Object.keys(breakpoints) as Breakpoint[]).forEach((bp) => {
      if (breakpoints[bp]) {
        result.push(
          keyPart
            ? `${prefix}${keyPart}${bp}-${breakpoints[bp]}`
            : `${prefix}${breakpoints[bp]}-${bp}`,
        );
      }
    });
  }
  return result;
}
